
















































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../main/components/main-header/main-header.vue";
import LeftNav from "../../system/components/left-nav.vue";
import { GetVersion, PostVersionData } from "@/request/app";
@Component({
  components: {
    MainHeader,
    LeftNav,
  },
})
export default class AppSetting extends Vue {
  private version: any = {
    version: "",
    url: "",
    tablet_version: "",
    tablet_url: "",
  };
  /**
   * @description 获取版本信息
   */
  private fetchVersion() {
    GetVersion(this).then((data: any) => {
      console.log(data);
      this.version = data;
    });
  }
  /**
   * @description 更新版本信息
   */
  private updateVersion() {
    // const versionReg: RegExp = /d+(.\d+){0,2}/;
    // if (!versionReg.test(this.version["version"])) {
    //   this.$message.error("版本号格式不对");
    //   return;
    // }
    if (!this.version.url) {
      this.$message.error("下载地址必须填写");
      return;
    }
    // if (!versionReg.test(this.version["tablet_version"])) {
    //   this.$message.error("平板版本号格式不对");
    //   return;
    // }
    if (!this.version.tablet_url) {
      this.$message.error("下载地址必须填写");
      return;
    }
    const params: any = this.version;
    PostVersionData(this, params).then((data: any) => {
      this.$message.success("更新成功");
      this.fetchVersion();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchVersion();
  }
}
